module.exports = __webpack_public_path__ + "img/Group 1366@2x.cd60eb24.png";